import React, { useState,useEffect } from 'react'
import Loader from '../../../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../../../CommonComponents/PiePage.component'
import InputField from '../../../../CommonComponents/InputMUI'
import SelectField from '../../../../CommonComponents/SelectMUI'
import MultiSelect from '../../../../CommonComponents/MultiSelectMUI'
import MultiInput from '../../../../CommonComponents/MutiInputTextField'
import { saveUpdateCommunityPersonalApi, getAllCommunityForParentCommunity, getCommunityPersonalApi } from '../../../AddEditDealer/DealerActioncreator'

const RoleTypeData = [
    {
        code: "operation",
        name: "Operation",
    },
    {
        code: "collection",
        name: "Collection",
    },
]

const VendorTypeData = [
    { code: "Dealer AGENT", name: "Dealer Agent" },
];


const branchesData = [
    {
        code: "gurugram",
        name: "Gurugram"
    }
];
const vendorBranchesData = [
    {
        code: "gurugram",
        name: "Gurugram"
    },
];
const gradeData = [
    {
        code: "A",
        name: "A"
    },
    {
        code: "B",
        name: "B"
    },
    {
        code: "C",
        name: "C"
    },
    {
        code: "D",
        name: "D"
    },
];
const isActiveData = [
    {
        code: true,
        name: "Active"
    },
    {
        code: false,
        name: "Inactive"
    }
]



export default function BasicDetails({ handlePage, handleTabs,commId,Detaildata,ParentcommId }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [parentVendorData , setParentVendorData] =useState([])
    const [ObjectData, setObjectData] = useState({
        name: '',
        mobileNumber: '',
        email: '',
        alternativeEmailId: '',
        multipleEmail: '',
        communityType: '',
        grade: '',
        parentCommunityId: ParentcommId,
        active: '',
        branches: [],
        vendorBranches:"",
        pointOfContact: '',
        panNumber: '',
        firmGstNumber: '',
        additionalInfo: '',
        communityRoleType: '',
    })


    useEffect(()=>{
        getAllCommunityForParentCommunity((callback)=>{
        
            if(callback && callback?.message == "success" && callback?.status == 200){
                setParentVendorData(callback?.data)
            }else{
                setParentVendorData([])
            }
        })
    },[])


    useEffect(()=>{
        if(Detaildata?.rowData?.communityId){
            setloaderState(true)
            getCommunityPersonalApi(Detaildata?.rowData?.communityId,(callback)=>{
                console.log("Detaildata?.communityId",callback)
                console.log("VendorTypeData?.filter((el)=> el.name === callback?.data?.communityType)",VendorTypeData?.filter((el) => el.name === callback?.data?.communityType).map(el => el.code))
                if(callback && callback?.status == 200 && callback?.message == "success"){
                    setObjectData({
                        name: callback?.data?.name || '',
                        mobileNumber: callback?.data?.mobileNumber || '',
                        email: callback?.data?.email || '',
                        alternativeEmailId: callback?.data?.alternativeEmailId || '',
                        multipleEmail: callback?.data?.multipleEmail || '',
                        communityType: (VendorTypeData?.filter((el) => el.name === callback?.data?.communityType).map(el => el.code))[0]  || '',
                        grade: callback?.data?.grade || '',
                        parentCommunityId: callback?.data?.parentCommunityId || '',
                        active: callback?.data?.active || '',
                        branches: callback?.data?.branches || [],
                        vendorBranches: callback?.data?.vendorBranches || "",
                        pointOfContact: callback?.data?.pointOfContact || '',
                        panNumber: callback?.data?.panNumber || '',
                        firmGstNumber: callback?.data?.firmGstNumber || '',
                        additionalInfo: callback?.data?.additionalInfo || '',
                        communityRoleType: callback?.data?.communityRoleType || '',
                    })
                }else{
                    setObjectData({
                        name: '',
                        mobileNumber: '',
                        email: '',
                        alternativeEmailId: '',
                        multipleEmail: '',
                        communityType: '',
                        grade: '',
                        parentCommunityId: ParentcommId,
                        active: '',
                        branches: [],
                        vendorBranches:"",
                        pointOfContact: '',
                        panNumber: '',
                        firmGstNumber: '',
                        additionalInfo: '',
                        communityRoleType: '',
                    })
                }
                setloaderState(false)
            })
        }
    },[Detaildata?.rowData])


    const inputChange = (e, type) => {
          
           let changeObjectData = Object.assign({}, ObjectData)

           if (type === 'mobileNumber' || type === 'email' || type === "alternativeEmailId") {
               
               if (type === 'mobileNumber') {
                   if (e.length <= 10) {
                       changeObjectData[type] = e
   
                   } else {
                       e = e.slice(0, 10)
                       // console.log(typeof (e))
   
                       changeObjectData[type] = e
                    
                   }
               }
               
               if (type === 'email' || type === "alternativeEmailId") {
                   if (type === 'email' || type === "alternativeEmailId") {
                       if (e.length <= 100) {
                           changeObjectData[type] = e
   
                       } else {
                           e = e.slice(0, 100)
   
                           changeObjectData[type] = e
                       
                       }
                   }
               }
   
           }
           else if (type === 'panNumber' && changeObjectData[type].length === 10) {
               changeObjectData[type] = e           
           }else{
            changeObjectData[type] = e    
           }
           
           setObjectData(changeObjectData)
         
       }


      const saveHandler = (e) => {
            if (e === 'save') {
                setloaderState(true)
                const obj = {...ObjectData}
                if(Detaildata?.rowData?.communityId){
                    obj.communityId = Detaildata?.rowData?.communityId,
                    obj.formStatus = "update"
                }
                saveUpdateCommunityPersonalApi(obj,(callback)=>{
                    setloaderState(false)
                    if (callback.data !== undefined && callback.data !== '' && callback.data !== null) {
                        commId(callback?.data?.communityId)
                        setTimeout(()=>{
                            handleTabs("address")
                        },200)
                    }
                })
            } else if (e === 'close') {
                handlePage("", "list")
            }
        }

    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                <PiePage
                    totalPage={3}
                    currentPage={1}
                    heading={'Add Basic Info'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Vendor Name"
                            variant="outlined"
                            value={ObjectData.name}
                            name="name"
                            id="name"
                            type="text"
                            onChange={e => inputChange(e, 'name')}
                            size="small"
                        // required={true}
                        />
                        {
                            errors?.name &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.name}</div>
                        }

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Contact Number"
                            variant="outlined"
                            value={ObjectData.mobileNumber}
                            name="mobileNumber"
                            id="mobileNumber"
                            type="number"
                            onChange={e => inputChange(e, 'mobileNumber')}
                            size="small"

                        />
                        {
                            errors?.mobileNumber &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.mobileNumber}</div>
                        }


                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Email Id"
                            variant="outlined"
                            value={ObjectData.email}
                            name="email"
                            id="email"
                            type="email"
                            onChange={e => inputChange(e, 'email')}
                            size="small"

                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Alternate Email Id"
                            variant="outlined"
                            value={ObjectData.alternativeEmailId}
                            name="alternativeEmailId"
                            id="alternativeEmailId"
                            type="email"
                            onChange={e => inputChange(e, 'alternativeEmailId')}
                            size="small"

                        />
                        {/* {
                            errors?.alternativeEmailId &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternativeEmailId}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Multiple Email Id"
                            variant="outlined"
                            value={ObjectData.multipleEmail}
                            name="multipleEmail"
                            id="multipleEmail"
                            type="email"
                            onChange={e => inputChange(e, 'multipleEmail')}
                            size="small"

                        />
                        {/* {
                            errors?.multipleEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.multipleEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.communityType}
                            label="Vendor Type"
                            onChange={e => inputChange(e, 'communityType')}
                            name="communityType"
                            data={VendorTypeData}
                            size={'small'}

                        />
                        {/* {
                            errors?.communityType &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.communityType}</div>
                        } */}

                    </div>
                </div>

                <div className="row">
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.grade}
                            label="Grade"
                            onChange={e => inputChange(e, 'grade')}
                            name="grade"
                            data={gradeData}
                            size={'small'}

                        />
                        {/* {
                            errors?.grade &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.grade}</div>
                        } */}

                    </div>
                    {/* <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.parentCommunityId}
                            label="Parent Vendor"
                            onChange={e => inputChange(e, 'parentCommunityId')}
                            name="parentCommunityId"
                            data={parentVendorData}
                            size={'small'}

                        />
                        

                    </div> */}

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.active}
                            label="Is Active ?"
                            onChange={e => inputChange(e, 'active')}
                            name="active"
                            data={isActiveData}
                            size={'small'}

                        />
                        {/* {
                            errors?.grade &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.grade}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>

                        <MultiSelect
                            label={"Select Branches"}
                            onChange={(e) => inputChange(e, "branches")}
                            value={ObjectData?.branches ? ObjectData?.branches : []}
                            inputData={branchesData} />
                        {/* {
                            errors?.grade &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.grade}</div>
                        } */}

                    </div>
                </div>

                <div className="row">

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.vendorBranches}
                            label="Vendor Branches"
                            onChange={e => inputChange(e, 'vendorBranches')}
                            name="vendorBranches"
                            data={vendorBranchesData}
                            size={'small'}

                        />
                        {/* {
                            errors?.grade &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.grade}</div>
                        } */}

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Point Of Contact"
                            variant="outlined"
                            value={ObjectData.pointOfContact}
                            name="pointOfContact"
                            id="pointOfContact"
                            type="text"
                            onChange={e => inputChange(e, 'pointOfContact')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="PAN Number"
                            variant="outlined"
                            value={ObjectData.panNumber}
                            name="panNumber"
                            id="panNumber"
                            type="text"
                            onChange={e => inputChange(e, 'panNumber')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                </div>

                <div className="row">

                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="GSTIN Number"
                            variant="outlined"
                            value={ObjectData.firmGstNumber}
                            name="firmGstNumber"
                            id="firmGstNumber"
                            type="text"
                            onChange={e => inputChange(e, 'firmGstNumber')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.communityRoleType}
                            label="Role Type"
                            onChange={e => inputChange(e, 'communityRoleType')}
                            name="communityRoleType"
                            data={RoleTypeData}
                            size={'small'}

                        />

                    </div>
                </div>

                <div className="row">
                    <div className=' col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            multiline={true}
                            label="Additonal Info"
                            variant="outlined"
                            value={ObjectData.additionalInfo}
                            name="additionalInfo"
                            id="additionalInfo"
                            type="text"
                            onChange={e => inputChange(e, 'additionalInfo')}
                            size="small"

                        />
                        {/* {
                            errors?.alternateEmail &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.alternateEmail}</div>
                        } */}

                    </div>
                </div>

                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">
                      
                            <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>
                            
                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save and Continue</button>
                    </div>
                </div>
            </div>
        </>
    )
}
